
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectGroup from '../../group/SelectGroup';
import GroupPop from '../../popup/GroupPop';
import SlotApi from '../../../api/SlotApi';
import GroupApi from '../../../api/GroupApi';
import RankTd from './RankTd';
import PageNavigation from '../../pageNavigation/PageNavigation';
import InputWithEnter from '../../common/InputWithEnter';
import AddSlot from './AddSlot';
import RankMemo from './RankMemo';
import DebounceBtn from '../../common/DebounceBtn';
import { dispatchLoading } from '../../../util/Http';
import UserContext from '../../../context/UserContext';
import { loginAlert } from '../../common/CustomAlert';

const PAGE_VIEW_OPTIONS = [
	{ label: 20, value : 20 },
	{ label: 30, value : 30 },
	{ label: 50, value : 50 }
]

const TITLE_MAP = {
	ST001 : '플레이스',
	ST002 : '쇼핑',
	ST007 : '쿠팡'
}

const RankBase = props => {
	const navigate = useNavigate();
	const { user } = useContext(UserContext);
    const { notice, type } = props;
	const [ slots, setSlots ] = useState([]);
	const [ totalCnt, setTotalCnt ] = useState(0);
    const [ searchKeyword, setSearchKeyword ] = useState('');
    const [ isCreateGroupPopOpen, setIsCreateGorupPopOpen ] = useState(false);
	const [ size, setSize ] = useState(PAGE_VIEW_OPTIONS[0].value);
	const [ page, setPage ] = useState(1);
	const [ groups, setGroups ] = useState([]);

	const [ selectGroupId, setSelectGroupId ] = useState(0);

    const handleSearchKeywordInput = e => {
        setSearchKeyword(e.target.value);
	}

	const handleSearchKeyowrdKeydow = e => {

	}

	const handleCreateGroupPopOpen = () => {
		setIsCreateGorupPopOpen(true);
	}

    const handleCreateGroupPopCloseBtn = isUpdated => {
        setIsCreateGorupPopOpen(false);
		if (isUpdated) getSlots({});
    }

	const handleSlotCheckbox = selectedSlot => {
		selectedSlot.isChecked = !selectedSlot.isChecked;
		setSlots([...slots]);
	}

	const handleAllCheckbox = () => {
		const newIsCheckedAll = !isCheckedAll();
		const newSlots = slots.map(slot => ({...slot, isChecked: newIsCheckedAll}));
		setSlots(newSlots);
	}

	const isCheckedAll = () => {
		if (slots.length === 0) return false;
		for (let i = 0; i < slots.length; i++) {
			if (!slots[i].isChecked) return false;
		}
		return true;
	}

	// 페이지 변경
	const handlePageChage = newPage => {
		if (!newPage || !user || !user.userId) return;
		setPage(newPage);
		getSlots({ newPage });
	}

	// 뷰 카운트 변경
	const handleViweCountChange = e => {
		const newSize = e.target.value;
		setSize(newSize);
		getSlots({ newSize });
	}

	// 그룹 변경
	const handleSelectGroupChange = newGroupId => {
		setSelectGroupId(newGroupId);
		getTotalCount({ newGroupId });
		getSlots({ newGroupId });
	}

	// 검색어 변경
	const handleSearchClick = () => {
		getTotalCount({});
		getSlots({});
	}

	// 슬롯 삭제
	const handleDeleteBtn = async () => {
		const confirmed = window.confirm("삭제하시겠습니까?");
		if (!confirmed) return;
		const ids = getSelectedSlots().map(slot => slot.slotId);
		const rslt = await SlotApi.deleteSlots(ids);
		if (rslt && rslt.code === 'success') {
			if (size === ids.length) {
				handlePageChage(1);
			} else {
				setSlots(slots.filter(slot => !slot.isChecked));
				setTotalCnt(totalCnt - ids.length);
			}
		}
		else alert('삭제에 실패했습니다.');
	}

	const handleManageGroup = () => {
		const res = window.confirm('그룹 관리 페이지로 이동하시겠습니까?')
		if (res) navigate('/mypage/group');
	}
	

	const handleXlsDownBtn = () => {
		SlotApi.xlsDownload(getSelectedSlots().map(s => s.slotId));
	}

	const handleReIndexingBtn = async () => {
		const selectedSlots = getSelectedSlots();
		selectedSlots.forEach(s => {
			// 슬롯 타입이 없는 케이스가 있음
			if (s.slotType) return;
			s.slotType = type;
		});
		const rslt = await SlotApi.reIndexSlot(selectedSlots);
		alert(rslt.message);
	}

	const handleBrandingReportBtn = async () => {
		const id = getSelectedSlots()[0].slotId;
		window.open(
			`/slot/brandingReport/${id}`, 
			'마케팅광장 브랜딩보고서', 
			`
				width=1000,
				height=800,
				top=100,
				left=100,
				resizable=no,
				scrollbars=yes,
				status=no,
				toolbar=no,
				menubar=no
			`
		);
	}

	const getSelectedSlots = () => {
		if (!slots || slots.length === 0) return [];
		return slots.filter(slot => slot.isChecked);
	};

	const isZero = () => getSelectedSlots().length === 0;

	const isNotOnlyOne = () => getSelectedSlots().length !== 1;

	const getSlots = (props = {}) => {
		const { 
			newPage = page, 
			newSize = size, 
			newSearchKeyword = searchKeyword, 
			newGroupId = selectGroupId 
		} = props;
		SlotApi.getSlots(newPage, newSize, newSearchKeyword, newGroupId, type ).then(setSlots);
	}

	const getTotalCount = (props = {}) => {
		const { 
			newSearchKeyword = searchKeyword, 
			newGroupId = selectGroupId 
		} = props;
		SlotApi.getSlotTotalCnt(newSearchKeyword, newGroupId, type)
			   .then(({totalCnt}) => setTotalCnt(totalCnt));
	}

	const handleAddComplete = async slot => {
		const { slotId = '' } = slot;
		if (!slotId) return;

		const newSlots = [slot, ...slots];
		// if (newSlots.length === size) newSlots.pop();
		// newSlots.unshift(slot);
		setSlots(newSlots);
		setTotalCnt(totalCnt+1);
	}

	const handleSetSlotProdNm = (slotId, prodNm) => {
		const newSlots = [...slots];
		const slot = newSlots.find(s => s.slotId === slotId);
		if (slot && slot.slotProdNm !== prodNm) {
			slot.slotProdNm = prodNm;
			setSlots(newSlots);
		}
	};

	const handleMemoChg = (slotId, memo) => {
		const newSlots = [...slots];
		const slot = newSlots.find(s => s.slotId === slotId);
		if (slot && slot.slotMemo !== memo) {
			slot.slotMemo = memo;
			setSlots(newSlots);
		}
	}

	useEffect(() => {
		if (!user || !user.userId) return;
		getTotalCount();
		GroupApi.getGroups().then(data => {
            if (!data) return;
            setGroups(data);
        });
	}, [user.userId])

    return (
        <div className="vh-content">
			{notice()}
			<AddSlot sectionTitle={TITLE_MAP[type]} groups={groups} type={type} addComplete={handleAddComplete} />
			<div className='section-area'>
				<div class="section-header">
					<h1 class="section-header-title">{TITLE_MAP[type]} 리스트</h1>
				</div>
				<div class="section-filter-group search-filter-group">
					<div class="section-filter-col">
						<select onChange={handleViweCountChange} value={size}>
							{PAGE_VIEW_OPTIONS.map(({ label, value }) => 
								<option value={value}>{label}개</option>
							)}
						</select>
						<span class="section-filter-label">전체 {totalCnt}건</span>
					</div>
					<div class="section-filter-col">
						<SelectGroup className={' '} groups={groups} selectCallback={handleSelectGroupChange} style={{width: 'auto'}} />
						<InputWithEnter 
							type="search" 
							placeholder="검색어를 입력해주세요" 
							value={searchKeyword}
							onChange={handleSearchKeywordInput} 
							enterCallback={handleSearchClick}
						/>
						<button type="button" class="btn btn-primary" onClick={handleSearchClick}>
							<i class="icon icon-24 icon-white icon-search-bold"></i>
						</button>
					</div>
				</div>
				<div className='section-content'>
					<div className='rank-result-area' >
						<div class="rank-result-tool">
							<DebounceBtn className={"btn"} onClick={handleManageGroup}>
								<i class="icon icon-group"></i>
								<span>그룹 관리</span>
							</DebounceBtn>
							<DebounceBtn className={"btn"} onClick={handleCreateGroupPopOpen} isDisabled={isZero()}>
								<i class="icon icon-exchange"></i>
								<span>그룹 변경</span>
							</DebounceBtn>
							<DebounceBtn className={"btn"} onClick={handleXlsDownBtn} isDisabled={isZero()}>
								<i class="icon icon-excel"></i>
								<span>엑셀 다운</span>
							</DebounceBtn>
							<DebounceBtn className={"btn"} onClick={handleReIndexingBtn} isDisabled={isZero()}>
								<i class="icon icon-black icon-search-bold"></i>
								<span>검색 요청</span>
							</DebounceBtn>
							<DebounceBtn className={"btn"} onClick={handleBrandingReportBtn} isDisabled={isNotOnlyOne()}>
								<i class="icon icon-report"></i>
								<span>브랜딩 보고서</span>
							</DebounceBtn>
							<DebounceBtn className={"btn btn-red"} onClick={handleDeleteBtn} isDisabled={isZero()}>
								<i class="icon icon-white icon-trash"></i>
								<span>삭제</span>
							</DebounceBtn>
						</div>
						{isCreateGroupPopOpen && <GroupPop selectedSlots={getSelectedSlots()} closed={handleCreateGroupPopCloseBtn} groups={groups} />}
						<div className='rank-result-table'>
							{slots.map(slot => {
								return (
								<div class="rank-result-row" key={`slot_${slot.slotId}`}>
									<div class="rank-result-head">
										<div class="checkbox">
											<input 
												type="checkbox" 
												checked={slot.isChecked}
												onChange={() => handleSlotCheckbox(slot)} 
											/>
											<label>{`[${slot.groupNm || '전체'}]`}</label>
										</div>
										<span class="primary bold">{slot.slotKeyword}</span>
										<span className='highlight3' title={slot.slotTargetNm}>{slot.slotTargetNm}</span>
										<span>{slot.slotProdNm || ''}</span>
									</div>

									<RankTd 
										ranks={slot.ranks} 
										slotId={slot.slotId} 
										type={type} 
										setSlotProdNm={slotProdNm => handleSetSlotProdNm(slot.slotId, slotProdNm)}
									/>
									<RankMemo slotId={slot.slotId} content={slot.slotMemo} callback={memo => handleMemoChg(slot.slotId, memo)} />
								</div>
							)})}
						</div>
					</div>
				</div>
			</div>
			{user.userId && <PageNavigation totalCount={totalCnt} showCount={size} onChange={handlePageChage} />}
		</div>
    )
}


export default RankBase;